import React, { useContext, useEffect, useState } from 'react'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  GridContainer,
  TextLabel,
  Text,
  Table,
  HeaderRow,
  HeaderCell,
  ItemRow,
  ItemCell,
  ButtonOfSection,
  ButtonOfSectionText,
  OptionsDiv,
  IconImg,
  DriverListDiv,
} from './style'
import ModalContext from '../../../../contexts/ModalContext'
import cross from '../../../../assets/orders/cross.svg'
import pen from '../../../../assets/router/edit-pen-white.svg'
import send from '../../../../assets/router/send.svg'
import share from '../../../../assets/router/share.svg'
import print from '../../../../assets/router/print.svg'
import correct from '../../../../assets/router/checked.svg'
import { RouterContext } from '../../../../contexts/RouterContext'
import { headersLabel, inputs, freights } from './utils'
import { mock } from '../../freightContent/freightForm/utils'
import RouterSection from '../../../../pages/ClientPanel/router'
import SectionContext from '../../../../contexts/SectionContext'
import { useNavigate } from 'react-router-dom'
import { ButtonCreate } from '../../style'
import axios from '../../../../config/axios'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import ModalTest from '../../../BaseModal'
import { Copy } from 'lucide-react'

export interface RouterInterface {
  status: string
  vehicle: any
  freight: any[]
  date: string
  origin: string
  id: number
  track: string
  url: string
  responsible: string
}

export interface Driver {
  name: string
  phone: string
}

const RouterDetail = () => {
  const dataFormatter = (isoDateString: string): string => {
    if (!isoDateString) {
      return '' // Retorna vazio se a string for nula ou vazia
    }

    const dateUtc = new Date(isoDateString)

    // Verifica se a data é válida antes de tentar formatar
    if (isNaN(dateUtc.getTime())) {
      console.error('Data ISO inválida recebida:', isoDateString)
      return '' // Trata o caso de uma string de data inválida
    }

    const getDrivers = async ()=>{
        const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route/utils/drivers`)
        const drivers = response.data
        setDrivers(drivers)
    }
    // Extrai as partes da data diretamente do UTC
    const year = dateUtc.getUTCFullYear()
    const month = dateUtc.getUTCMonth() + 1 // getUTCMonth é 0-indexado, então adiciona 1
    const day = dateUtc.getUTCDate()

    // Garante que mês e dia tenham dois dígitos (ex: 01 em vez de 1)
    const formattedMonth = month < 10 ? `0${month}` : month
    const formattedDay = day < 10 ? `0${day}` : day

    return `${formattedDay}/${formattedMonth}/${year}`
  }
  const { setModalActive } = useContext(ModalContext)
  const { router, setRouter } = useContext(RouterContext)
  const { routerSection, setRouterSection } = useContext(SectionContext)
  const [shortUrl, setShortUrl] = useState<string>('')
  const { setFeedback } = useContext(FeedbackContext)
  const [drivers, setDrivers] = useState<Driver[]>([])
  const [visibleDriver, setVisibleDriver] = useState<boolean>(false)
  const [visibleCopy, setVisibleCopy] = useState<boolean>(false)
  const navigate = useNavigate()
  const [routerModel, setRouterModel] = useState({
    status: router?.status || '',
    vehicle: router?.vehicle || null,
    freight: router?.freight || [],
    date: router?.date || '',
    origin: router?.origin || '',
    id: router?.id || 0,
    track: router?.track,
    responsible: router?.responsible,
  })

  const close = () => {
    // setModalActive(false)
    setRouter(null)
    navigate('/panel/router/routers')
  }

  const handleEdit = () => {
    setModalActive(false)
    setRouterSection('newRouter')
    navigate('/panel/router/routers/edit')
  }

  const getDrivers = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route/utils/drivers`,
    )
    const drivers = response.data
    setDrivers(drivers)
  }

  useEffect(() => {
    const fetchDrivers = async () => {
      await getDrivers()
    }
    fetchDrivers()
  }, [])

  const DriverListener = () => {
    // <div key={1} style={{height:'8rem', marginTop: '0.5rem', width:'100%'}}>
    // <ButtonCreate  key={1}style={{ flexGrow: 1, height: '70%',  width:'100%',marginBottom: '0.5rem',textAlign:"start", }} onClick={()=>handleFeedback('11966804912')}><div style={{width: '70%', display: 'flex', justifyContent: 'center'}}><p style={{textAlign:'center'}}>{'Rich'}</p></div> <div style={{width: '30%', display: 'flex', justifyContent: 'center'}}><IconImg style={{width:'1.3rem', height:'1.3rem', /*marginLeft: '1rem',*/}} src={send}></IconImg></div></ButtonCreate>
    //         </div>
    return (
      <>
        <DriverListDiv>
          <Text style={{ marginBottom: '0', marginTop: '0' }}>Motoristas</Text>

          {drivers.map((driver: any, index: number) => {
            return (
              <div
                key={index}
                style={{ height: '8rem', marginTop: '0.5rem', width: '100%' }}
              >
                <ButtonCreate
                  key={index}
                  style={{
                    flexGrow: 1,
                    height: '70%',
                    width: '100%',
                    marginBottom: '0.5rem',
                    textAlign: 'start',
                  }}
                  onClick={() => handleFeedback(driver.phone)}
                >
                  <div
                    style={{
                      width: '70%',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <p style={{ textAlign: 'center' }}>{driver.name}</p>
                  </div>{' '}
                  <div
                    style={{
                      width: '30%',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <IconImg
                      style={{
                        width: '1.3rem',
                        height: '1.3rem' /*marginLeft: '1rem',*/,
                      }}
                      src={send}
                    ></IconImg>
                  </div>
                </ButtonCreate>
              </div>
            )
          })}
        </DriverListDiv>
      </>
    )
  }

  const handleFeedback = (phoneNumber: string) => {
    const url = feedbackGenerator(router, phoneNumber)

    window.open(url, '_blank')
  }
  const urlShorter = async (url: string) => {
    try {
      const response = await axios.get(
        `https://tinyurl.com/api-create.php?url=${url}`,
      )
      const linkshort = response.data

      return linkshort
    } catch (error) {
      console.error('Failed to fetch short URL:', error)
    }
  }
  useEffect(() => {
    const fetchShortUrl = async () => {
      if (router && router.url) {
        try {
          const response = await axios.get(
            `https://tinyurl.com/api-create.php?url=${router.url}`,
          )
          const routerUtl = response.data

          setShortUrl(routerUtl)
        } catch (error) {
          console.error('Failed to fetch short URL:', error)
        }
      }
    }
    fetchShortUrl()
  }, [router])

  const feedbackGenerator = (router: any, phoneNumber: string) => {
    const freigths = router?.freight

    // Constrói a parte dos endereços separadamente para ter controle total sobre as quebras de linha.
    const addresses = freigths
      .map((freight: any, index: number) => {
        return `
*Frete ${index + 1}:* 

*Tipo:* ${freight.type}
*Cliente:* ${freight.company.companyName}
*Carga:* ${freight.load.weight}kg, ${freight.load.length}x${
          freight.load.width
        }x${freight.load.height}
${freight.load.detail ? `*detalhe da carga:* ${freight.load.detail}` : ''}
*Local:* ${freight.address.street}, ${freight.address.number}
*Observação*: ${freight.observation}
*Link:* ${mapsLinkGenerator(freight)}
`
      })
      .join('\n\n') // Garante uma quebra de linha entre cada endereço

    const message = `
*Olá! Uma rota foi atribuida a você*
        
*Data:* ${dataFormatter(router?.date)}
*Tempo estimado de trajeto:* ${router?.track.split('-')[0]}
*Distância:* ${router?.track.split('-')[1]}
        
*Pontos de entrega:*\n
${addresses}

*Rota completa:* ${shortUrl}\n   
> Ordeno`

    const encodedMessage = encodeURIComponent(message)
    // const phoneNumber = '+5511966804912'; // Substitua pelo número de telefone

    const whatsappUrl = `https://wa.me/+55${phoneNumber}?text=${encodedMessage}`
    // const whatsappUrl = `https://wa.me/+5511966804912?text=${encodedMessage}`;

    return whatsappUrl
  }

  const completeRoute = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route/${router?.id}/completed`,
      )
      const responseRoute = await axios.get(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route/${router?.id}`,
      )

      setRouter(responseRoute.data)
      setFeedback({
        isOpen: true,
        message: 'Rota completa!',
        statusOk: true,
      })
    } catch {
      setFeedback({
        isOpen: true,
        message: 'Erro ao concluir rota',
        statusOk: false,
      })
    }
  }
  const wazeLinkGenerator = (freight: any) => {
    if (!freight || !freight.address) {
      console.warn("Objeto 'freight' ou 'freight.address' inválido.")
      return ''
    }

    const street = freight.address.street
    const number = freight.address.number
    const neighborhood = freight.address.neighborhood.name
    const city = freight.address.neighborhood.city.name
    const state = freight.address.neighborhood.city.state.uf // Acessa a UF do estado

    // Monta a string do endereço. Quanto mais completo, melhor a precisão do Waze.
    // Usamos template literals para facilitar a concatenação.
    const addressString = `${street}, ${number}, ${neighborhood}, ${city}, ${state}`

    // Codifica a string do endereço para ser utilizada em uma URL.
    // O encodeURIComponent é essencial para tratar espaços, vírgulas e caracteres especiais.
    const encodedAddress = encodeURIComponent(addressString)

    // Constrói o link completo do Waze.
    return `https://waze.com/ul?q=${encodedAddress}`
  }

  const mapsLinkGenerator = (freight: any) => {
    if (!freight || !freight.address) {
      console.warn("Objeto 'freight' ou 'freight.address' inválido.")
      return ''
    }

    // Pega as informações do endereço do objeto freight
    const street = freight.address.street
    const number = freight.address.number
    const neighborhood = freight.address.neighborhood.name
    const city = freight.address.neighborhood.city.name
    const state = freight.address.neighborhood.city.state.uf

    // Monta a string do endereço de forma completa para maior precisão
    const addressString = `${street}, ${number}, ${neighborhood}, ${city}, ${state}`

    // Codifica a string do endereço para ser usada em uma URL
    // O encodeURIComponent é essencial para tratar espaços, vírgulas, etc.
    const encodedAddress = encodeURIComponent(addressString)
    // Constrói o link completo do Google Maps usando a URL base e o parâmetro 'q'
    // const urlShorted = urlShorter(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`)

    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`
  }
  const calculateVolume = (
    weight: number,
    height: number,
    length: number,
    width: number,
  ): string => {
    const volume = (height * length * width) / 1_000_000 // Convertendo cm³ para m³
    const formattedWeight = weight.toLocaleString('pt-BR') // Adicionando separação de milhares

    return `${volume.toFixed(3)}m³ ${formattedWeight}kg`
  }

  const generateCompleteMessage = (
    router: any,
    complete: boolean,
    shortUrl: string,
  ) => {
    const freights = router?.freight

    if (!freights || freights.length === 0) {
      return 'Nenhum frete encontrado.'
    }

    const generateFreightMessage = (
      freight: any,
      index: number,
      isComplete: boolean,
    ) => {
      let message = ''

      // Linha do cabeçalho sempre existe
      if (isComplete) {
        message += `*Frete ${index + 1} (${freight.type}) - `
      } else {
        message += `*${index + 1}º (${freight.type})* - ${
          freight.company?.companyName || ''
        }`
        if (freight.observation) {
          message += ` - ${freight.observation}`
        }
        message += '\n'
      }

      if (isComplete) {
        if (freight.company?.companyName) {
          message += `${freight.company.companyName}*\n`
        }

        // ... dentro da sua função que gera a mensagem

        // Carga
        const dimensionParts = []
        if (freight.load.length > 0) {
          dimensionParts.push(`${freight.load.length}`)
        }
        if (freight.load.width > 0) {
          dimensionParts.push(`${freight.load.width}`)
        }
        if (freight.load.height > 0) {
          dimensionParts.push(`${freight.load.height}`)
        }

        // Montando a linha de Carga de forma inteligente
        const loadParts = []

        if (freight.load?.weight > 0) {
          loadParts.push(`${freight.load.weight}kg`)
        }

        // Adiciona as dimensões apenas se alguma delas foi preenchida
        if (dimensionParts.length > 0) {
          loadParts.push(dimensionParts.join('x'))
        }

        if (freight.load?.detail) {
          loadParts.push(`${freight.load.detail}`)
        }

        if (loadParts.length > 0) {
          message += `*Carga:* ${loadParts.join(' / ')}\n`
        }

        if (freight.observation) {
          message += `*Obs:* ${freight.observation}\n`
        }
      }

      // Linha de Local - para ambas as versões
      const addressParts = []
      if (freight.address?.street) {
        addressParts.push(freight.address.street)
      }
      if (freight.address?.number) {
        addressParts.push(freight.address.number)
      }
      if (freight.address?.neighborhood.city.name) {
        addressParts.push(freight.address.neighborhood.city.name)
      }
      if (addressParts.length > 0) {
        message += `*Local:* ${addressParts.join(', ')}\n`
      }

      // Linha de Link - para ambas as versões
      const mapLink = mapsLinkGenerator(freight)
      if (mapLink) {
        message += `*Link:* ${mapLink}\n`
      }

      return message
    }

    // Mapeia e gera a mensagem para cada frete
    const freightsMessages = freights
      .map((freight: any, index: number) =>
        generateFreightMessage(freight, index, complete),
      )
      .join('\n\n')

    // Constroi a mensagem final com base na flag 'complete'
    if (complete === false) {
      const summaryMessage = `*Olá! Uma rota foi atribuída a você - Data: ${dataFormatter(
        router?.date,
      )}*\n\n${freightsMessages}\n\n*Rota completa:* ${shortUrl}\n`
      return summaryMessage
    } else {
      const fullMessage = `*Olá! Uma rota foi atribuída a você - Data: ${dataFormatter(
        router?.date,
      )}*\n\n*Tempo estimado de trajeto:* ${
        router?.track?.split('-')[0] || ''
      }\n*Distância:* ${
        router?.track?.split('-')[1] || ''
      }\n\n${freightsMessages}\n\n*Rota completa:* ${shortUrl}\n`
      return fullMessage
    }
  }

  /*   const generateCompleteMessage = (router: any, complete: boolean) => {
    const freigths = router?.freight

    const addresses = freigths
      .map((freight: any, index: number) => {
        return `
*Frete ${index + 1} (${freight.type})*: 
*Cliente:* ${freight.company.companyName}
*Carga:* ${freight.load.weight}kg, ${freight.load.length}x${
          freight.load.width
        }x${freight.load.height} / ${
          freight.load.detail
            ? `*detalhe da carga:* ${freight.load.detail}`
            : ''
        }
*Local:* ${freight.address.street}, ${freight.address.number} - ${
          freight.address.city
        }
*Observação*: ${freight.observation}
*Link:* ${mapsLinkGenerator(freight)}
`
      })
      .join('\n\n')
    const addressesResumed = freigths
      .map((freight: any, index: number) => {
        return `
*${index + 1}º (${freight.type})* - ${freight.company.companyName} - ${
          freight.observation
        }
*Local:* ${freight.address.street}, ${freight.address.number}
*Link:* ${mapsLinkGenerator(freight)}
`
      })
      .join('\n\n')

    if (complete === false) {
      const summaryMessage = `
*Olá! Uma rota foi atribuida a você - Data: ${dataFormatter(router?.date)}*
        
*Pontos de entrega:*\n
${addressesResumed}

*Rota completa:* ${shortUrl}\n`
      return summaryMessage
    } else {
      // Sua lógica original para a mensagem completa
      const fullMessage = `
*Olá! Uma rota foi atribuida a você - Data: ${dataFormatter(router?.date)}*

*Tempo estimado de trajeto:* ${router?.track.split('-')[0]}
*Distância:* ${router?.track.split('-')[1]}
        
*Pontos de entrega:*\n
${addresses}

*Rota completa:* ${shortUrl}\n`
      return fullMessage
    }
  }
 */
  const handleCopyComplete = async (complete: boolean) => {
    if (!router) {
      console.error('Dados da rota não disponíveis.')
      return
    }

    const textToCopy = generateCompleteMessage(router, complete, shortUrl)

    try {
      await navigator.clipboard.writeText(textToCopy)
      setFeedback({
        isOpen: true,
        message: 'Mensagem completa copiada!',
        statusOk: true,
      })
    } catch (err) {
      setFeedback({
        isOpen: true,
        message: 'Falha ao copiar a mensagem.',
        statusOk: false,
      })
      console.error('Falha ao copiar texto: ', err)
    }
  }

  return (
    <>
      <ModalTest>
        <Container>
          <GridContainer>
            <HeaderDiv style={{ gridArea: 'titleNew' }}>
              <HeaderText>Roteiro: {router?.id}</HeaderText>
              <CloseDiv onClick={() => close()}>
                <CloseImg src={cross} alt='Close tab' />
              </CloseDiv>
            </HeaderDiv>

            <TextLabel style={{ gridArea: 'dateLabel' }}>Data:</TextLabel>
            <Text style={{ gridArea: 'date' }}>
              {' '}
              {dataFormatter(router?.date || '')}
            </Text>
            {inputs.map((input) => {
              const value = router?.[input.field]

              return (
                <React.Fragment key={input.field}>
                  <TextLabel style={{ gridArea: input.field + 'Label' }}>
                    {input.label}
                  </TextLabel>
                  <Text style={{ gridArea: input.field }}>
                    {input.field === 'vehicle' &&
                    typeof value === 'object' &&
                    value !== null &&
                    !Array.isArray(value)
                      ? value.plate
                      : typeof value === 'string' || typeof value === 'number'
                      ? value
                      : '-'}
                  </Text>
                </React.Fragment>
              )
            })}
          </GridContainer>

          <Text style={{ marginLeft: '1.5rem' }}>Roteiro:</Text>

          <Table>
            <HeaderRow>
              {headersLabel.map((header) => {
                return <HeaderCell key={header}>{header}</HeaderCell>
              })}
            </HeaderRow>
            {router?.freight.map((freight: any, index) => {
              return (
                <>
                  <ItemRow key={freight.id}>
                    <ItemCell>{index + 1}</ItemCell>
                    <ItemCell className='link'>{freight.id}</ItemCell>
                    <ItemCell>{freight.company.companyName}</ItemCell>
                    <ItemCell>{freight.type}</ItemCell>
                    <ItemCell>
                      {freight.address.street +
                        ', ' +
                        freight.address.number +
                        ' - ' +
                        freight.address.neighborhood.city.name +
                        '/' +
                        freight.address.neighborhood.city.state.uf}
                    </ItemCell>
                    <ItemCell>
                      {calculateVolume(
                        Number(freight.load.weight),
                        Number(freight.load.height),
                        Number(freight.load.length),
                        Number(freight.load.width),
                      )}
                    </ItemCell>
                    <ItemCell className='link'>
                      {' '}
                      <a href={wazeLinkGenerator(freight)}>Acessar</a>
                    </ItemCell>
                  </ItemRow>
                </>
              )
            })}
          </Table>
          <OptionsDiv>
            {/* <a href={router?.url}>link</a> */}
            <ButtonCreate className='reverse'>
              <IconImg src={print}></IconImg>
              Imprimir
            </ButtonCreate>
            {/* <a href={router?.url}>Maps</a> */}
            <ButtonCreate onClick={() => handleEdit()}>
              <IconImg src={pen}></IconImg>
              Editar
            </ButtonCreate>
            <div
              style={{
                width: '20%',
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
              }}
            >
              <ButtonCreate
                style={{ width: '90%' }}
                onClick={() => handleCopyComplete(true)}
              >
                <Copy
                  style={{ width: '1rem', height: '1rem', marginRight: '3px' }}
                ></Copy>
                Copiar rota
              </ButtonCreate>
            </div>
            {/* {router?  <a href={ feedbackGenerator(router)}>Feedback</a>:<span>teste</span>} */}
            <div
              style={{
                width: '20%',
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
              }}
            >
              <ButtonCreate
                style={{ width: '90%' }}
                onClick={() => setVisibleDriver(!visibleDriver)}
              >
                <IconImg
                  style={{ width: '1rem', height: '1rem' }}
                  src={share}
                ></IconImg>
                Compartilhar
              </ButtonCreate>
              {visibleDriver ? <DriverListener /> : null}
            </div>
            <ButtonCreate
              onClick={async () => {
                await completeRoute()
              }}
            >
              <IconImg
                style={{ width: '1rem', height: '1rem' }}
                src={correct}
              ></IconImg>
              Concluir rota
            </ButtonCreate>
          </OptionsDiv>
        </Container>
      </ModalTest>
    </>
  )
}

export default RouterDetail

